import { getGroup } from "../sanity/client";
import SlugPage from "../components/slugPage";
import { Link, useParams } from "react-router-dom";
import useSWR from "swr";

export default function Group() {
  const { slug } = useParams();
  const { data: content } = useSWR(
    slug ? `group-${slug}` : null,
    () => getGroup(slug!).then((r) => r[0])
  );

  return (
    <>
      <Link to="/groups">&lt; Back to all groups</Link>
      {content && <SlugPage columned content={content} />}
    </>
  );
}
